import React from 'react';
import { ReactComponent as ArrowIcon } from '@Assets/icons/next.svg';
import './index.scss';
export interface iColeccion{
    nombre: string;
    codigo:string;
    medios: Array<{nombre:string , codigo:string}>;
    clicked?: (col:string, med:string)=> void;
}

export default (props:iColeccion) => {
    return (
        <details className="c_accordion__detail">  
            <summary className="c_accordion__summary"><p className="e-h4 e-h6:md">Colecciones {props.nombre}</p><span className="c_accordion__summary_icon"><ArrowIcon/></span></summary>  
            <ul className="c_accordion__list">
                {props.medios &&
                    props.medios.map((medio, index) =>{
                        return (
                            <li key={index} onClick={()=>{if(props.clicked){props.clicked(props.codigo,medio.codigo)}}} className="c_accordion__list_item e-p3 e-text-regular">{medio.nombre}</li>
                        )
                    })
                }
            </ul>
        </details>
    )
}